angular.module( 'acme.view.application.membership.benefits.modals.create', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.membership.benefits.modals.create.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var membershipBenefitsModalsCreate = {
        name: 'application.membership.benefits.modals.create',
        url: '/membership/benefits/modals/create',
        views: {
          "main": {
            controller: 'MembershipBenefitsModalsCreateController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/membership/benefits/modals/create/create.tpl.html'
          }
        },
        data: {
          pageTitle: '    ',
          /** Secure With Permissions **/
          permissions: []
        }
      };

    $stateProvider
      .state(membershipBenefitsModalsCreate);
});
